/**
 * Meldungen an den Benutzer.
 *
 * Jede Meldung sagt, was mit dem Vorgang passiert ist — nicht nur, dass
 * etwas schiefging. „Der Vorgang wurde nicht gespeichert" ist die
 * Information, die zählt: Sie entscheidet, ob man es noch einmal versucht.
 */
import type { ReactNode } from 'react';

export type Ton = 'gefahr' | 'warnung' | 'gut' | 'info';

const ZEICHEN: Record<Ton, string> = {
  gefahr: '✕',
  warnung: '!',
  gut: '✓',
  info: 'i',
};

export function Meldung({
  ton = 'info',
  titel,
  children,
}: {
  ton?: Ton;
  titel?: string;
  /* `children` bleibt englisch: Das ist der Name, unter dem JSX
     verschachtelte Elemente übergibt — wie `className` oder `onClick` kein
     eigener Bezeichner, sondern eine Schnittstelle von React. */
  children: ReactNode;
}): ReactNode {
  return (
    <div className={`meldung ${ton}`} role={ton === 'gefahr' ? 'alert' : 'status'}>
      <span className="zeichen" aria-hidden="true">
        {ZEICHEN[ton]}
      </span>
      <div>
        {titel ? <strong>{titel} </strong> : null}
        {children}
      </div>
    </div>
  );
}

/** Kurzform für Fehlertexte aus useVorgang oder useAbruf. */
export function Fehlermeldung({ text }: { text: string | null }): ReactNode {
  if (!text) return null;
  return <Meldung ton="gefahr">{text}</Meldung>;
}
